import React from 'react';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter, formatName } from '../utils/capitalize';
import { formatDateToDDMMYYYY } from '../utils/dates';

interface UserIdCardProps {
    firstName: string;
    lastName: string;
    color?: string;
    id: string;
    username: string;
    codeProC?: string;
    profileType?: string;
    address?: string;
    job?: string;
    arrivalDate?: Date;
    phoneNumber?: string;
    isSst?: boolean;
    isSpecial?: boolean;
    className?: string;
}

const UserIdCard: React.FC<UserIdCardProps> = ({
    firstName,
    lastName,
    id,
    username,
    codeProC,
    profileType,
    address,
    job,
    arrivalDate,
    phoneNumber,
    isSst,
    isSpecial,
    className = '',
    color,
}) => {
    const { t } = useTranslation();

    return (
        <div className={`bg-black text-white border-radius-10px pad-10px w-100 max-w-400px fx-c gap-15px ${className}`}>
            <div className="border-b-1px border-white pad-b-5px" style={{ borderColor: color }}>
                <div className="xlFont font-w-700 fx-r fx-items-c gap-10px">
                    {color && <div style={{ width: 8, height: 8, backgroundColor: color, borderRadius: 10 }} />}
                    {formatName(firstName, lastName)}
                </div>
                {profileType && <span className="font-italic">{capitalizeFirstLetter(profileType)}</span>}
            </div>
            <div className="fx-c gap-5px">
                <div>
                    <span className="font-w-700">{capitalizeFirstLetter(t('id'))} :</span> {id}
                </div>
                <div>
                    <span className="font-w-700">{capitalizeFirstLetter(t('userlogin'))} :</span> {username}
                </div>
                {codeProC && (
                    <div>
                        <span className="font-w-700">{capitalizeFirstLetter(t('codeProC'))} :</span> {codeProC}
                    </div>
                )}
                {job && (
                    <div>
                        <span className="font-w-700">{capitalizeFirstLetter(t('job'))} :</span> {job}
                    </div>
                )}
                {address && (
                    <div>
                        <span className="font-w-700">{capitalizeFirstLetter(t('address'))} :</span> {address}
                    </div>
                )}
                {arrivalDate && (
                    <div>
                        <span className="font-w-700">{capitalizeFirstLetter(t('arrivalDate'))} :</span> {formatDateToDDMMYYYY(arrivalDate, '/')}
                    </div>
                )}
                {phoneNumber && (
                    <div>
                        <span className="font-w-700">{capitalizeFirstLetter(t('mobile'))} :</span> {phoneNumber}
                    </div>
                )}
                {isSst && (
                    <div>
                        <span className="font-w-700">{capitalizeFirstLetter(t('isSst'))} :</span> {t('yes')}
                    </div>
                )}
                {isSpecial && (
                    <div>
                        <span className="font-w-700">{capitalizeFirstLetter(t('isSpecial'))} :</span> {t('yes')}
                    </div>
                )}
            </div>
        </div>
    );
};

export default UserIdCard;
